module.exports = __webpack_public_path__ + "img/slider-ebadge.45320629.png";